import { render, staticRenderFns } from "./DialogCollegamentiAnagrafiche.vue?vue&type=template&id=7defdc42&"
import script from "./DialogCollegamentiAnagrafiche.vue?vue&type=script&lang=js&"
export * from "./DialogCollegamentiAnagrafiche.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports